export class EmailAlreadyExistError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EmailAlreadyExistError';
    Object.setPrototypeOf(this, EmailAlreadyExistError.prototype);
  }
}
